/**
 * Escapes a string to be used inside a regular expression (escapes reg-exp
 * magic characters with back slashes).
 */
const escapeRegExp = string =>
	string.replace(/([.$?*|{}()[\]\\/+\-^])/g, chr => "\\" + chr);

/**
 * Returns the root of the hostname, which are the two top level domains.
 */
const getRootHostname = () => {
	return "." + window.location.hostname.split(".").slice(-2).join(".");
};

/**
 * Return a cookie value given its name, or null if teh cookie is not set.
 */
export const getCookie = name => {
	const regexp = new RegExp(
		"(?:(?:^|.*;\\s*)" +
			escapeRegExp(encodeURIComponent(name)) +
			"\\s*\\=\\s*([^;]*).*$)|^.*$",
	);
	const matches = document.cookie.match(regexp);
	return matches && matches[1] ? decodeURIComponent(matches[1]) : null;
};

/**
 * Sets the given cookie, sets the "secure" option by default. Optionally
 * adds an expires flag.
 */
export const setCookie = (name, value, options = {}) => {
	const merged = {
		domain: getRootHostname(),
		path: "/",
		samesite: "lax",
		secure: true,
		...options,
	};

	const cookieParts = Object.keys(merged).map(key => {
		const value = merged[key];
		if (value === true) {
			return `${key}`;
		} else if (value instanceof Date) {
			return `${key}=${value.toUTCString()}`;
		} else if (value !== null && value !== undefined) {
			return `${key}=${value}`;
		}
	});

	document.cookie = [
		encodeURIComponent(name) + "=" + encodeURIComponent(value),
		...cookieParts,
	].join(" ;");
};

/**
 * Removes a cookie, given its name.
 */
export const unsetCookie = name => {
	setCookie(name, "", { expires: -1 });
};

/**
 * Returns true if cookies are available and enabled in the current
 * environment, false otherwise.
 */
export const areCookiesAvailable = () => {
	const name = "__esc_test_cookie";
	const random = Math.random().toString(16);

	setCookie(name, random);

	let available = false;
	if (getCookie(name) === random) {
		unsetCookie(name);
		available = true;
	}

	return available;
};
